import React from 'react';
import styled from 'styled-components';

const MobileOrgAdminExperience: React.FC = () => (
  <PageWrapper>
    <PageTitle>Org Admin Mobile</PageTitle>
    <PageText>
      This is the mobile experience for organization administrators. You can access insights, team data, and admin tools from the mobile portal.
    </PageText>
  </PageWrapper>
);

export default MobileOrgAdminExperience;

const PageWrapper = styled.div`
  display: grid;
  gap: 16px;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  margin: 0;
  color: #111827;
`;

const PageText = styled.p`
  font-size: 16px;
  color: #475569;
  line-height: 1.6;
`;
